/* eslint-disable @typescript-eslint/no-explicit-any */

import { jwtDecode } from 'jwt-decode';
import { IJwtDecoded, IJwtService } from './jwt-service';

export class JwtServiceImpl implements IJwtService {
  getDataFromToken(data: string): IJwtDecoded {
    return jwtDecode(data);
  }
}
